//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import WaybillFlightPhotos from '../Waybill/WaybillFlightPhotos.vue'
import StockKittingToolReserve from '../StockTools/StockKittingToolReserve.vue'
import StockKittingToolSearcher from '../StockTools/StockKittingToolSearcher.vue'
import StockKittingToolAmountExceededIcon from '../StockTools/StockKittingToolAmountExceededIcon.vue'
import { filterFn, createFieldConfig } from '../../components/QSelectUtils.js'

export default {
  components: {
    StockKittingToolAmountExceededIcon,
    WaybillFlightPhotos: WaybillFlightPhotos,
    StockKittingToolReserve: StockKittingToolReserve,
    StockKittingToolSearcher: StockKittingToolSearcher
  },
  props: {
    modelTool: {
      type: Object,
      default: null
    },
    state: {
      type: String,
      default: null
    },
    manager: {
      type: Object,
      required: true
    },
    request: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isTransfer: {
      type: Boolean,
      default: false
    },
    consistBrigadeStocks: {
      type: Array,
      default: null
    },
    excludedToolIds: {
      type: Array,
      default: null
    }
  },
  data: function () {
    return {
      model: this.getEmptyModel(),
      sourceBrigade: null,
      loading: false,
      opened: false,
      thumbStyle: {
        right: '4px',
        borderRadius: '5px',
        background: '#A9A9A9',
        width: '10px',
        opacity: 1
      },
      newRecord: true,
      validSave: false,
      toolFieldConfig: createFieldConfig(this.getTools, true, r => r.tool.name),
      stockFieldConfig: createFieldConfig(this.getStocks),
      stockAutoFilled: false,
      toolSearcherOpened: false,
      amountPart1: 0,
      amountPart2: 0,
      validTransferStock: false,
      validInputStock: true,
      fractionalInputMode: false,
      oldStock: null
    }
  },
  computed: {
    isMobileDevice: function () {
      const isMobile = this.$store.getters.getUser.view === 'mobile'
      return isMobile
    },
    isPartAmountValid: function () {
      return this.manager.ignoreLimits || parseFloat(this.amountPart1 + '.' + this.amountPart2) <= this.model.amountStock
    },
    factor: function () {
      let targetStockAmount = 'Не определено'
      let amountStock = 'Не определено'
      let amountFree = 'Не определено'
      if (this.model && this.model.targetStockAmount != null) {
        targetStockAmount = this.isInt(this.model.tool.unit) ? this.model.targetStockAmount : this.model.targetStockAmount.toFixed(3)
      }
      if (this.model && this.model.amountStock != null) {
        amountStock = this.isInt(this.model.tool.unit) ? this.model.amountStock : this.model.amountStock.toFixed(3)
      }
      if (this.model && this.model.amountFree != null) {
        amountFree = this.isInt(this.model.tool.unit) ? this.model.amountFree : this.model.amountFree.toFixed(3)
      }
      if (targetStockAmount === 'Не определено' && amountStock === 'Не определено' && amountFree === 'Не определено') {
        return null
      } else {
        return targetStockAmount + ' / ' +
          amountStock + ' / ' +
          amountFree + ' ' + this.model.tool.unit
      }
    },
    showPhotos: function () {
      return !!(this.model && this.model.tool && this.model.tool.images && this.model.tool.images.length)
    },
    amountMaxRecommended: function () {
      if (this.manager.ignoreLimits) {
        return Number.MAX_SAFE_INTEGER
      }
      if (this.model && this.model.amountFree != null) {
        return this.model.amountFree
      }
      return 0
    },
    amountHint: function () { // !!!
      if (this.state !== 'SK5' && this.model && this.model.amount != null) {
        if (this.manager.ignoreLimits) {
          return null
        }
        return 'Количество должно быть больше 0, но не превышать ' + this.amountMaxRecommended
      }
      return null
    },
    amountIssued: function () {
      if (!this.model || this.model.amountIssued == null) {
        return 'Не определено'
      }
      return this.model.tool && this.isInt(this.model.tool.unit)
        ? String(this.model.amountIssued)
        : this.model.amountIssued.toFixed(3)
    },
    amountFieldBackgroundColor: function () {
      if (this.state !== 'SK5' && this.manager.isToolAmountExceeded(this.model)) {
        return this.manager.ignoreLimits ? 'orange-2' : 'red-2'
      }
      return null
    }
  },
  watch: {
    fractionalInputMode: function (result) {
      if (result) {
        this.amountPart1 = (this.model && this.model.amount) ? parseInt(this.model.amount) : 0
        this.amountPart2 = String(this.model.amount).split('.')[1] ? String(this.model.amount).split('.')[1] : 0
      } else {
        if (this.model && this.model.amount) {
          this.model.amount = parseInt(this.model.amount)
        }
        this.amountPart1 = 0
        this.amountPart2 = 0
      }
    }
  },
  methods: {
    isValidFormSave: function () {
      let amountValid = false
      if (this.model && this.model.amount) {
        amountValid = this.manager.ignoreLimits || (parseFloat(this.model.amount) > 0.000) && (parseFloat(this.model.amount) <= parseFloat(this.model.amountStock))
      }
      return (this.model && this.model.tool !== null /* && this.model.stock !== null */ && amountValid)
    },
    isReadonlyTools: function () {
      const validStock = this.model && !!this.model.stock
      return this.readonly ? true : (this.isTransfer ? !validStock : false)
    },
    isReadonlyStock: function () {
      const canInput = this.sourceBrigade
      const canRead = this.readonly || this.model.tool != null || this.oldStock
      return this.isTransfer ? (canRead || !canInput) : canRead
    },
    IsNumber (event) {
      const pattern = /\d/
      if (!event.key.match(pattern) || event.key == '.') {
        return event.preventDefault()
      }
    },
    isInt: function (unit) {
      return ['упак', 'бут', 'пар', 'компл', 'рул', 'мешок', 'лист', 'усл. шт', 'шт'].includes(unit)
    },
    onOpen: function (isNew) {
      this.newRecord = !!isNew
      this.opened = true
      if (!this.newRecord) {
        this.fractionalInputMode = false
        this.model = JSON.parse(JSON.stringify(this.modelTool))
        if (this.model.tool) {
          const fractional = String(this.model.amount).split('.')
          if (fractional[1] && parseInt(fractional[1])) {
            this.fractionalInputMode = true
          }
          if (this.isInt(this.model.tool.unit) && !this.fractionalInputMode) {
            this.model.amount = parseInt(this.model.amount)
          } else {
            this.amountPart1 = parseInt(this.model.amount)
            this.amountPart2 = String(this.model.amount).split('.')[1]
          }
        }
        if (!this.model.tool.images) {
          this.loadToolImages(this.model.tool.key)
        }
      } else {
        this.fractionalInputMode = false
        this.model = this.getEmptyModel()
        if (this.oldStock) {
          this.setStock(this.oldStock, true)
        }
      }
      this.validTransferStock = !this.isReadonlyTools()
      this.validSave = this.isValidFormSave()
      this.validInputStock = !this.isReadonlyStock()
    },
    getStocks: function (text = '') {
      const urlParams = new URLSearchParams()
      urlParams.set('searchSource', true)
      urlParams.set('name', text)
      urlParams.set('showDisabled', false)
      urlParams.set('stationaryMain', true)
      if (!this.isTransfer) {
        urlParams.set('type', 'stationary,auto,brigade,common')
        urlParams.set('tsfree', false)
      } else {
        if (this.sourceBrigade) {
          urlParams.set('brigadeId', this.sourceBrigade.id)
        }
      }
      if (this.request.organization) {
        urlParams.set('organization', this.request.organization.id)
      }
      if (this.manager.targetStockId != null) {
        urlParams.set('targetId', this.manager.targetStockId)
      }

      return axiosGet({
        url: '/service/delta/stock/kitting/request/searchStocks?' + urlParams.toString(),
        onSuccess: (response) => {
          return response.data
            /* .filter(element => {
              let e = true
              if (!this.isTransfer && element.stockType === 'stationary' &&
                !['База Бережковская', 'Хозяйственный', 'Склад Материалы заказчика'].includes(element.stockName)) {
                e = false
              }
              return e
            }) */
            .filter(element => {
              const brigadeStocks = !this.isTransfer && this.consistBrigadeStocks ? this.consistBrigadeStocks.map(item => item.id) : []
              if (!this.isTransfer && this.request.stock && this.request.stock.id) {
                brigadeStocks.push(this.request.stock.id)
              }
              return (this.isTransfer || !brigadeStocks.length) ? true : !brigadeStocks.includes(element.stockId)
            })
            .map(element => {
              return {
                id: element.stockId,
                name: element.stockName + (element.gosNumber ? (' ' + element.gosNumber) : ''),
                key: element.stockKey,
                type: element.stockType,
                gosNumber: element.gosNumber
              }
            })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка загрузки списка складов',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка загрузки списка складов'))
        }
      })
    },
    filterFnStock (val, update, abort) {
      return filterFn(val, update, abort, this.stockFieldConfig)
    },
    setStock: function (val, autoFilled) {
      this.model.stock = val
      this.model.stockName = val ? val.name : null
      this.stockAutoFilled = !!autoFilled
      if (this.$refs.selectStock) {
        this.$refs.selectStock.resetValidation()
      }
      this.validTransferStock = !this.isReadonlyTools()
      this.cancelField('selectStock')
    },
    getTools: function (text = '') {
      const urlParams = new URLSearchParams()
      urlParams.set('name', text)
      urlParams.set('showDisabled', false)
      urlParams.set('stationaryMain', true)
      if (this.model.stock) {
        urlParams.set('stock', this.model.stock.key)
      }
      if (this.request.stock && this.request.stock.id) {
        urlParams.set('targetId', this.request.stock.id)
      }
      if (this.request.id) {
        urlParams.set('requestId', this.request.id)
      }

      return axiosGet({
        url: '/service/delta/stock/kitting/request/searchTools?' + urlParams.toString(),
        onSuccess: (response) => {
          let tools = response.data.result
          tools = tools.filter(tool => !this.excludedToolIds.includes(tool.tool.id))
          return tools
          /* .filter(element => {
              let e = true
              if (!this.isTransfer && element.stock.stockType === 'stationary' &&
                !['База Бережковская', 'Хозяйственный', 'Склад Материалы заказчика'].includes(element.stock.stockName)) {
                e = false
              }
              return e
            }) */
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка загрузки списка материалов',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка загрузки списка материалов'))
        }
      })
    },
    filterFnTools (val, update, abort) {
      if (this.toolSearcherOpened) {
        this.$refs.selectTools.hidePopup()
        return
      }
      return filterFn(val, update, abort, this.toolFieldConfig)
    },
    setTool: function (val) {
      this.amountPart1 = 0
      this.amountPart2 = 0
      let foundTool = null
      if (val != null) {
        // Проверка на уже введенные в форме данные по выбранному материалу для исключения превышения по количеству в 1С !!!
        if (this.request && this.request.tools.length) {
          foundTool = this.request.tools.find((item) => {
            return item.tool.key == val.tool.key && item.tool.id == val.tool.id
          })
        }
        //
        this.model.tool = (foundTool && foundTool !== undefined) ? foundTool.tool : val.tool
        this.model.tool.value = (foundTool && foundTool !== undefined) ? foundTool.tool.id : val.tool.id
        this.model.tool.label = (foundTool && foundTool !== undefined) ? foundTool.tool.name : val.tool.name
        const toolKey = (foundTool && foundTool !== undefined) ? foundTool.tool.key : val.tool.key
        this.loadToolImages(toolKey)
        if (foundTool && foundTool !== undefined) {
          this.newRecord = false
          this.$nextTick(() => {
            const fractional = String(foundTool.amount).split('.')
            if (fractional[1] && parseInt(fractional[1])) {
              this.model.amount = foundTool.amount
              this.fractionalInputMode = true
            }
          })
        } else {
          this.model.amount = val.amount
        }
        this.model.targetStockAmount = (foundTool && foundTool !== undefined) ? foundTool.targetStockAmount : val.targetStockAmount
        this.model.otherAgreedRequestsAmount = (foundTool && foundTool !== undefined) ? foundTool.otherAgreedRequestsAmount : val.otherAgreedRequestsAmount
        this.model.otherRequestsAmount = (foundTool && foundTool !== undefined) ? foundTool.otherRequestsAmount : val.otherRequestsAmount
        this.model.otherRequestsRecords = (foundTool && foundTool !== undefined) ? foundTool.otherRequestsRecords : val.otherRequestsRecords
        this.model.amountStock = (foundTool && foundTool !== undefined) ? foundTool.amountStock : val.amountStock
        this.model.amountFree = (foundTool && foundTool !== undefined) ? foundTool.amountFree : val.amountFree
        this.model.amountIssued = (foundTool && foundTool !== undefined) ? foundTool.amountIssued : val.amountIssued
        this.model.reserve = (foundTool && foundTool !== undefined) ? foundTool.reserve : val.reserve
        this.model.inventoryReserveInfo = (foundTool && foundTool !== undefined) ? foundTool.inventoryReserveInfo : val.inventoryReserveInfo
        this.model.toolName = (foundTool && foundTool !== undefined) ? foundTool.tool.name : val.tool.name
        this.$refs.modelAmount.$el.focus()
        if (!this.model.stock) {
          const stock = {
            id: (foundTool && foundTool !== undefined) ? foundTool.stock.stockId : val.stock.stockId,
            name: (foundTool && foundTool !== undefined) ? foundTool.stock.stockName : val.stock.stockName,
            key: (foundTool && foundTool !== undefined) ? foundTool.stock.stockKey : val.stock.stockKey,
            type: (foundTool && foundTool !== undefined) ? foundTool.stock.stockType : val.stock.stockType
          }
          this.setStock(stock, true)
        }
      } else {
        const stock = this.stockAutoFilled ? null : this.model.stock
        this.model = this.getEmptyModel()
        this.setStock(stock, false)

        this.$refs.selectTools.resetValidation()
      }
      this.validInputStock = !this.isReadonlyStock()
      this.cancelField('selectTools')
    },
    getEmptyModel: function () {
      this.amountPart1 = 0
      this.amountPart2 = 0
      return {
        tool: null,
        stock: null,
        amount: null,
        amountStock: null,
        amountFree: null,
        reserve: null,
        inventoryReserveInfo: null,
        toolName: null,
        stockName: null
      }
    },
    loadToolImages: function (toolId) {
      this.$set(this.model.tool, 'images', [])

      this.loading = true
      return axiosGet({
        url: '/service/delta/report/toolPhoto/' + toolId,
        onSuccess: (response) => {
          this.model.tool.images = response.data.result.map(imageRaw => {
            return {
              url: '/service/delta/document/read?id=' + imageRaw.id,
              name: 'Фото материала на ' + new Date().toLocaleString()
            }
          })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка загрузки фото материала',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка загрузки фото материала'))
        },
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    onSave: function () {
      this.$emit('change', { model: JSON.parse(JSON.stringify(this.model)), newRecord: this.newRecord })
      this.opened = false
    },
    onInputAmount: function () {
      this.validSave = this.isValidFormSave()
    },
    onEnter: function () {
      this.$refs.selectTools.$el.focus()
    },
    onInputAmountPart: function () {
      this.model.amount = parseFloat(this.amountPart1 + '.' + this.amountPart2)
      this.validSave = this.isPartAmountValid
    },
    cancelField: function (refKey) {
      const input = this.$refs[refKey] ? this.$refs[refKey].$refs.target : null
      if (input) {
        input.blur()
      }
    },
    onExtendedToolSearch: function () {
      this.toolSearcherOpened = true
    },
    onExtendedToolSelected: function (val) {
      this.toolSearcherOpened = false
      this.setTool(val)
    },
    getOptionIcon: function (type, parameter) {
      let result = parameter == 'color' ? 'grey' : 'mdi-help-circle-outline'
      switch (type) {
        case 'auto':
          result = parameter == 'color' ? 'secondary' : 'mdi-car'
          break
        case 'brigade':
          result = parameter == 'color' ? 'cyan' : 'mdi-account-group'
          break
        case 'stationary':
          result = parameter == 'color' ? 'green' : 'mdi-home-map-marker'
          break
        default:
          break
      }
      return result
    }
  }
}

